import { render, staticRenderFns } from "./Payables.vue?vue&type=template&id=2f8ef988&"
import script from "./Payables.vue?vue&type=script&lang=js&"
export * from "./Payables.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports